var HOME = $('body').hasClass('home');
var BRAND = $('body').hasClass('brand');
var SEARCH = $('body').hasClass('search-result');
var PRODUTO = $('body').hasClass('product');
var CATALOG = $('body').hasClass('catalog');
var ACCOUNT = $('body').hasClass('account');
var CATEGORY = $('body').hasClass('category');
var DEPARTMENT = $('body').hasClass('department');
var EMPTYSEARCH = $('body').hasClass('empty-search');
var INSTITUTIONAL = $('body').hasClass('institutional');

var MOBILEBREAK = 767;
var TABLETBREAK = 1025;

var fns = {
  acordeon: function () {
    $('.acordeon-wrap .acordeon-toggle').slideUp();
    $('.acordeon-start').live('click', function () {
      $(this).parents('.acordeon-wrap').find('.acordeon-toggle').slideToggle();
    })
  },

  isMobile: function () {
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.search(/(android|avantgo|blackberry|iemobile|nokia|lumia|bolt|boost|cricket|docomo|fone|hiptop|mini|mobi|palm|phone|pie|tablet|up\.browser|up\.link|webos|wos)/i) != -1) {
      $('.lightboxOverlay').remove();
    };
  },

  verifyWidth: function () {
    if ($(window).width() <= 1024) {
      $('body').addClass('isMobile');
      $('body').removeClass('notMobile');
      return true
    } else {
      $('body').removeClass('isMobile');
      $('body').addClass('notMobile');
      return false
    }
  },

  sliderScroll: function (target) {
    var select = target;

    $(select).slideDown(function () {
      $('html, body').animate({
        scrollTop: 0
      }, 600);
    });
  },

  resizeHeigth: function (largura, altura, larguraDesejada) {
    var total = altura * larguraDesejada;
    total = total / largura;
    var dimensions = {
      largura: larguraDesejada,
      altura: total
    }
    return dimensions;
  },

  formObject: function ($form) {
    var obj = {};
    $form.find('input').each(function () {
      var value;
      var name;
      if ($(this).attr('type') == 'checkbox' && $(this).is(':checkd')) {
        value = $(this).val();
        name = $(this).attr('name');
      }
      if ($(this).attr('type') == 'option' && $(this).is(':checkd')) {
        value = $(this).val();
        name = $(this).attr('name');
      }
      if ($(this).attr('type') != 'option' && $(this).attr('type') != 'checkbox') {
        value = $(this).val();
        name = $(this).attr('name');
      }
      obj[name] = value;

    });
    $form.find('select').each(function () {
      var value = $(this).find('option:selected').val();
      var name = $(this).attr('name');
      obj[name] = value;
    });
    $form.find('textarea').each(function () {
      var value = $(this).val();
      var name = $(this).attr('name');
      obj[name] = value;
    });
    return obj;
  },

  tab: function () {
    $('.details-abas .aba').on('click', function () {
      $('.details-abas .aba, .wrap-aba').removeClass('active');

      var _this = $(this);
      var target = _this.attr('data-target');

      _this.addClass('active');
      $('.details-abas .wrap-aba' + target).addClass('active');

    })
  },

  customScroll: function (element) {
    element.mCustomScrollbar({
      axis: "y"
    });
  },

  saveMasterDate: function (entidade, dataInfo) {
    $.ajax({
      url: 'https://api.vtexcrm.com.br/uniformeasy/dataentities/' + entidade + '/documents/',
      dataType: 'json',
      type: 'PATCH',
      crossDomain: true,
      data: JSON.stringify(dataInfo),
      headers: {
        'Accept': 'application/vnd.vtex.ds.v10+json',
        'Content-Type': 'application/json; charset=utf-8'
      },
      success: function (dataJson) {
        alert('Dados salvos com sucesso!')
      }
    });
  },

  validaEmail: function (email) {
    var re = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
    return re.test(email);
  },

  newsletter: function ($form) {
    $form.on('submit', function (e) {
      e.preventDefault();
      var fields = fns.formObject($form);
      if (fields.email.length == 0 || fields.nome.length == 0) {
        alert('Preencha todos os campos!')
      } else {
        if (fns.validaEmail(fields.email)) {
          $.ajax({
            headers: {
              "Accept": "application/vnd.vtex.ds.v10+json",
              "Content-Type": "application/json",
              "REST-Range": "resources=0-1"
            },
            type: 'GET',
            url: "https://api.vtexcrm.com.br/uniformeasy/dataentities/NL/search?_fields=id,email&_where=email=" + fields.email

          }).done(function (clientInfo) {
            if (clientInfo.length == 0) {
              fns.saveMasterDate('NL', fields);
            } else {
              alert('Esse E-mails já foi cadastrados!');
            }
          })
        }
      }
    })
  }
}


var slider = {
  slideShelf: function ($shelf, desktopShow, tabletShow, mobileShow, desktopScroll, tabletScroll, mobileScroll, desktopDots, tabletDots, mobileDots, desktopArrow, tabletArrow, mobileArrow) {
    $shelf.slick({
      infinite: false,
      dots: desktopDots,
      arrows: desktopArrow,
      slidesToShow: desktopShow,
      slidesToScroll: desktopScroll,
      nextArrow: '<button type="button" class="slick-arrow slick-next"><i class="ico-arrow"></i></button>',
      prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="ico-arrow"></i></button>',
      responsive: [{
        breakpoint: TABLETBREAK,
        settings: {
          dots: tabletDots,
          arrows: tabletArrow,
          slidesToShow: tabletShow,
          slidesToScroll: tabletScroll,
        }
      },
      {
        breakpoint: MOBILEBREAK,
        settings: {
          dots: mobileDots,
          arrows: mobileArrow,
          slidesToShow: mobileShow,
          slidesToScroll: mobileScroll,
        }
      },
      ]
    });
  },
  singleSlider: function ($element, dots, arrows, other = {}) {
    const config = Object.assign(
      {
        autoplay: false,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        pauseOnDotsHover: true,
        pauseOnFocus: false,
      },
      other,
      {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: dots,
        arrows: arrows,
        nextArrow: '<button type="button" class="slick-arrow slick-next"><i class="ico-arrow"></i></button>',
        prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="ico-arrow"></i></button>'
      }
    )
    $element.slick(config);
    $element.data('slick-config', JSON.stringify(config));
  },
  thumbProductSlider: function () {

  }
}

const home = {

  init: function () {
    slider.singleSlider($('.fullGallery'), true, true, {
      autoplay: true,
    });
    slider.slideShelf($('.featuredProducts .main-shelf > ul'), 5, 3, 1, 2, 2, 1, false, false, true, true, true, true);
    slider.slideShelf($('.slider__school .slider'), 4, 3, 1, 2, 2, 1, false, false, true, true, true, true);

    $(".text-seo a.button").on("click", function (e) {
      e.preventDefault(),
        $(".text-seo .toggle-text").slideToggle(),
        $(this).fadeOut()
    }),
      MOBILEBREAK >= window.innerWidth && $(".tip-bar ul").slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: !1,
        arrows: !1,
        autoplay: !0,
        autoplaySpeed: 2e3
      })
  }
}

const product = {
  productBreadCrumb: function () {
    var e = `<li class="last"> ${$("h1.productTitle").text()} </li>`;
    $(".bread-crumb ul").append(e),
      $(".toggle-troca").slideToggle(),
      $(".troca-facil").on("click", function (e) {
        e.preventDefault(),
          $(".toggle-troca").slideToggle()
      }),
      setTimeout(function () {
        var e = $("#reviews").find("p.media"),
          t = $("#reviews")
            .find("p.media")
            .next(),
          a = $("#reviews").find("div.avalie-produto"),
          o = $("#reviews")
            .find("div.avalie-produto")
            .next();
        $("<div class='avalDireita'></div>").insertAfter("#reviews ul.rating"),
          $("#reviews .avaliacao").prepend("<div class='avalEsquerda'></div>"),
          $(".avalEsquerda").append(e, t),
          $(".avalDireita").append(a, o),
          $("#reviews #lnkPubliqueResenha").text("AVALIAR")
      }, 600)
  },
  slider: function () {
    slider.slideShelf(
      $(".productComplementary .main-shelf > ul"),
      5,
      3,
      1,
      5,
      4,
      1,
      !1,
      !1,
      !0,
      !0,
      !0,
      !0
    )
  },
  qtl: function () {
    $(".prodQtd span").on("click", function () {
      var e = $(this),
        t = parseInt($(".prodQtd .qtdValue").val());
      e.hasClass("removeItem")
        ? t <= 0
          ? t = 0
          : t--
        : t++,
        $(".prodQtd .qtdValue").val(t)
    })
  },
  thumbSlider: function () {
    $("#show .thumbs img").each(function () {
      var e = $(this),
        t = e
          .attr("src")
          .replace("-80-70", "-400-400");
      e.attr("src", t)
    }),
      $("#show ul.thumbs").slick({
        dots: !1,
        arrows: !0,
        vertical: !0,
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: !1,
        nextArrow: '<button type="button" class="slick-arrow slick-next"><i class="ico-arrow"></i>' +
          '</button>',
        prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="ico-arrow"></i>' +
          '</button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              dots: !0,
              arrows: !0,
              slidesToShow: 1,
              slidesToScroll: 1,
              vertical: !1,
              infinite: !0
            }
          }, {
            breakpoint: 425,
            settings: {
              dots: !0,
              arrows: !1,
              slidesToShow: 1,
              slidesToScroll: 1,
              vertical: !1,
              infinite: !0
            }
          }
        ]
      })
  },
  showUnavailable: function () {
    var e = $(".shipping");
    skuJson.available || e.hide()
  },
  productUnavailable: function () {
    skuJson.available || $(".buyProductButton").addClass("no-stock")
  },
  shipping: function () {
    $("#form-shipping input").mask("99.999-999"),
      $("#form-shipping").on("submit", function (e) {
        e.preventDefault();
        var t = $("#form-shipping input")
          .val()
          .replace(/[.-]/g, "");
        $
          .get("/frete/calcula/437?shippinCep=" + t + "&quantity=1")
          .done(function (e) {
            $(".shipping .result").html(""),
              $(".shipping .result").html($(e))
          })
      })
  },
  measures: function () {
    $(".specification").append($(".seeMeasures")),
      $(".seeMeasures").on("click", function (e) {
        e.preventDefault();
        var t = $(".group.Medidas")
          .offset()
          .top;
        $("body, html").animate({
          scrollTop: t - 200
        }, 600)
      })
  },
  init: function () {
    product.slider(),
      product.thumbSlider(),
      product.showUnavailable(),
      product.qtl(),
      product.productUnavailable(),
      product.shipping(),
      product.productBreadCrumb(),
      product.measures(),
      $(window).on("skuSelected", function () {
        $("#show ul.thumbs").slick("unslick"),
          setTimeout(function () {
            product.thumbSlider()
          }, 500)
      }),
      $("#espeCurta table").prepend(
        $("#specification #caracteristicas table.Especificacoes").html()
      ),
      $(".Tabela-de-medidas br").remove(),
      $(
        '<div class="videoMedida" id="videoMedida"><i class="fa fa-play" aria-hidden="t' +
        'rue"></i><a data-toggle="modal" rel="modal:open" href="#myModal">Clique e assi' +
        'sta como medir</a></div>'
      ).insertAfter("#caracteristicas h4.Medidas");
    var e = ($(".value-field.Video")
      .html() || '')
      .replace("\x3c!--", "")
      .replace("--\x3e", "");
    $("#myModal .modal-body").append(e),
      $('a[data-toggle="modal"]').on("click", function (e) {
        e.preventDefault(),
          $("#myModal").modal({
            escapeClose: !1,
            clickClose: !0,
            showClose: !0
          })
      })
  }
};

const catalog = {
  init: function () {
    if (
      catalog.numberResult(),
      catalog.groupFilters(),
      catalog.smartResearch(),
      catalog.menuFilterToggle(),
      catalog.orders(),
      catalog.seoText(),
      catalog.buttonTop(),
      0 != $(".section-header .wrap-text").text().length && $(".section-header").addClass("show"),
      $("body").hasClass("search") && catalog.identifySearchPage(),
      $("body").hasClass("search")
    ) {
      var e = `\n        <div class="search-title">\n          <h2> Você buscou por: <strong> "${vtxctx.searchTerm}" </strong> </h2>\n        </div>\n      `;
      $(".section-header").after(e)
    }
  },
  buttonTop: function () {
    $("body").append($("<button>", { id: "back-top" })),
      $("#back-top").on("click", function () {
        $("header.pageHeader").slideDown(function () {
          $("html, body").animate({
            scrollTop: 0
          }, 600)
        })
      })
  },
  identifySearchPage: function () {
    $(".menu-navegue").length
      ? fns.customScroll($(".search-multiple-navigator fieldset div"))
      : ($("body").addClass("firstLevel"), catalog.searchBradCrumb())
  },
  numberResult: function () {
    var e = $(".searchResultsTime .resultado-busca-numero .value")
      .eq(0)
      .text();
    $(".productResult").append(
      "<span>Produtos encontrados: <strong>" + e + "</strong></span>"
    )
  },
  menuFilterToggle: function () {
    $(".filterMobileToggle").on("click", function (e) {
      fns.verifyWidth() && (
        e.preventDefault(),
        $(".navSidebar").addClass("open"),
        $("body").addClass("menuOpen"),
        $(".navOverlay").addClass("active").fadeIn(300)
      )
    }),
      $(".navSidebarHead .ico-close, .navOverlay").on("click", function (e) {
        fns.verifyWidth() && (
          e.preventDefault(),
          $(".navSidebar").removeClass("open"),
          $("body").removeClass("menuOpen"),
          $(".navOverlay").removeClass("active").fadeOut(300)
        )
      })
  },
  searchBradCrumb: function () {
    var e = $(".searchResultsTime .resultado-busca-termo .value")
      .eq(0)
      .text(),
      t = $('<li class="last"><a href="/">Busca: ' + e + " X</a></li>");
    $(".bread-crumb ul").append(t)
  },
  searchResult: function () { },
  emptySearch: function () {
    var e = $('meta[name="Abstract"]').attr("content");
    $(".box-emptySearch h3 span em").text(e)
  },
  groupFilters: function () {
    if (vtxctx.departmentyId !== vtxctx.categoryId) {
      $('.search-single-navigator').find('h3, h4, h5, h5 + ul').hide();
    } else {
      $('.search-single-navigator').find('h3, h4 + ul, h5, h5 + ul').hide();
    }
    $(".search-single-navigator ul").each(function () {
      $(this)
        .find("li")
        .length
        ? fns.customScroll($(this))
        : ($(this).prev().addClass("noItems"), $(this).remove())
    }),
      $(".filterOptions h4, .filterOptions h5").each(function () {
        $(this).hasClass("noItems") || $(this)
          .addClass("hided")
          .append('<i class="ico-arrow"></i>')
      }),
      $(".filterOptions h4 i, .filterOptions h5 i").on("click", function () {
        $(this)
          .parent()
          .stop(!0, !0)
          .toggleClass("hided")
      });
    var e = $(".bread-crumb .last").text(),
      t = $(".resultado-busca-numero .value")
        .eq(0)
        .text();
    $(".info-navigator .page-name").text(e),
      $(".info-navigator .outher-info span").text(t)
  },
  orders: function () {
    $(".orderBy.filters").on("click", function () {
      $(this)
        .find(".contentOrders")
        .slideToggle()
    }),
      $(".contentOrders .buttonOrder").live("click", function (e) {
        e.preventDefault();
        var t = $(this).attr("href");
        if ("" != window.location.search || window.location.search.length > 0) {
          var a = window
            .location
            .search
            .split("&O")[0];
          window.location.href = window.location.pathname + a + "&O=" + t
        } else
          window.location.href = window.location.pathname + "?PS=12&O=" + t
      });
    var e = $(".resultado-busca-numero span.value")
      .eq(0)
      .text();
    $("#numbe-result").append(e),
      $("#orderBy").on("change", function (e) {
        e.preventDefault();
        var t = $(this)
          .find("option:selected")
          .val();
        if ("" != window.location.search || window.location.search.length > 0) {
          var a = window
            .location
            .search
            .split("&O")[0];
          window.location.href = window.location.pathname + a + "&O=" + t
        } else
          window.location.href = window.location.pathname + "?PS=12&O=" + t
      })
  },
  searchInEmptySearch: function () {
    $("#btnBuscar")
      .off()
      .on("click", function (e) {
        e.preventDefault();
        var t = $("#text-search").val();
        t.length
          ? window.location = window.location.origin + "/" + t
          : alert("Digite o que você está procurando!")
      })
  },
  seoText: function () {
    $(".seo-text button").on("click", function () {
      $(this)
        .parents(".seo-text")
        .find(".content")
        .toggleClass("open")
    }),
      $(".seo-text .content")
        .text()
        .length > 0 && $(".seo-text").show()
  },
  smartResearch: function () {
    $(".navSidebar .filterOptions input[type='checkbox']").vtexSmartResearch({
      loadContent: ".main-shelf[id^=ResultItems]",
      shelfClass: ".main-shelf",
      ajaxCallback: function () {
        $("li.helperComplement").remove()
      },
      shelfCallback: function () {
        $("li.helperComplement").remove()
      }
    })
  }
};

const emptSearch = {
  wordSearch: function () {
    var e = $('meta[name="Abstract"]').attr("content");
    $("strong.result").text(e)
  },
  init: function () {
    this.wordSearch()
  }
};

const search = {
  breadCrumb: function () {
    var e = $('meta[name="Abstract"]').attr("content");
    $(".bread-crumb ul").append(
      '<li class="last">Resultado de busca: ' + e.split("–")[0] + "</li>"
    )
  },
  init: function () {
    search.breadCrumb()
  }
};

var global = {
  isLogged: function () {
    vtexjs.checkout.getOrderForm().done(function (data) {
      var userName;
      if (data.loggedIn) { // Se logado
        if (data.clientProfileData.firstName != null) {
          userName = data.clientProfileData.firstName;
        } else {
          userName = data.clientProfileData.email;
        }

        $('.main-section .enterAccount .login span').text('Minha conta');
        $('.main-section .enterAccount .login').html('<span>Olá ' + userName + '</span><div class="triangle" style="top: 10px"></div>');

        $('.mobili-navegation .header-menu > .login').remove();

        $('.navHead .titel a').html('<span>Olá ' + userName + '</span><div class="triangle"></div>');
        $('.mobili-navegation .header-menu > .select').html('<span><i class="ico-user"></i> Olá ' + userName + '</span>');
        $('.mobili-navegation .header-menu').append('<ul><li><a href="/account">Minha conta</a></li><li><a href="/account/orders">Meus pedidos</a></li><li><a href="/logout">Sair</a></li></ul>');
        $('.accountMobileNav .content').slideDown();

        $('.pageNav .navHead .greeting .welcomeMsg span').text('Olá ' + userName);
        $('.pageNav .navHead .greeting .welcomeMsg span').append('<a href="/account">Minha conta</a>');
      } else { // se NÃO logado
        $('.mobili-navegation .header-menu').append('<ul><li><a href="/account">Minha conta</a></li><li><a href="/account/orders">Meus pedidos</a></li><li><a href="/Login">Login</a></li></ul>');
        $('.mobili-navegation .header-menu ul').slideUp();

        $('.mobili-navegation .header-menu .triangle').on('click', function (e) {
          e.preventDefault();
          $('.mobili-navegation .header-menu ul').slideToggle();
        });
      }
    });
  },
  selectToggle: function () {
    $.ajax({
      url: '/api/sessions/?items=*',
      dataType: 'json',
      type: 'GET',
      headers: {
        'Accept': 'application/vnd.vtex.ds.v10+json',
        'Content-Type': 'application/json; charset=utf-8'
      },
      success: function (dataJson) {
        const profile = ((dataJson || {}).namespaces || {}).profile;
        const name = ((profile || {}).firstName || {}).value;
        const email = ((profile || {}).email || {}).value;
        const info = name || email;
        if (info) {
          $('.enterAccount .slect-text a').html(info);
        }
      }
    });
    // $('.enterAccount .select, .enterAccount .triangle').live('click', function (e) {
    //   e.preventDefault();
    //   if ($(this).parents('.dropdown').hasClass("active")) {
    //     $(this).parents('.dropdown').removeClass("active");
    //   } else {
    //     $(this).parents('.dropdown').addClass("active");
    //   }
    // });
  },
  menuToggle: function () {
    $(".toggle-menu--button, #menu-mobile .overlay, #menu-mobile .toggle-menu").on(
      "click",
      function (e) {
        $("#menu-mobile").toggleClass("open")
      }
    ),
      $("#menu-mobile .sub-menu").slideToggle(),
      $("#menu-mobile .open-sub").on("click", function (e) {
        $(this)
          .parents("li")
          .find(".sub-menu")
          .slideToggle()
      }),
      $(".fundamental-i-e-ii a").on("mouseover", function (e) {
        fns.verifyWidth() || (
          e.preventDefault(),
          $(".fundamental-i-e-ii ul.list").slideDown(),
          $("ul#ii, ul#infantil").slideUp()
        )
      }),
      $(".fundamental-ii a").on("mouseover", function (e) {
        fns.verifyWidth() || (
          e.preventDefault(),
          $(".fundamental-ii ul.list").slideDown(),
          $("ul#i-e-ii, ul#infantil").slideUp()
        )
      }),
      $(".infantil a").on("mouseover", function (e) {
        fns.verifyWidth() || (
          e.preventDefault(),
          $(".infantil ul.list").slideDown(),
          $("ul#i-e-ii, ul#ii").slideUp()
        )
      }),
      $(".item1 a").mouseover(function (e) {
        e.preventDefault(),
          $("ul.maple-bear").addClass("active")
      }),
      $("li.item1, ul.maple-bear").mouseleave(function (e) {
        $("ul.maple-bear").removeClass("active"),
          e.preventDefault()
      }),
      $(".searbutton").on("click", function () {
        $(".searchBox").slideToggle()
      }),
      $(".navigation-bar .toggle-menu").on("mouseover", function (e) {
        e.preventDefault(),
          $(".navigation-bar .sub-menu-nav").slideDown(100)
      }),
      $(".navigation-bar .sub-menu-nav").on("mouseleave", function (e) {
        e.preventDefault(),
          $(this).slideToggle(100)
      })
  },
  searchResizeImage: function () {
    $(document).ajaxStop(function () {
      setTimeout(function () {
        if ($('.ui-autocomplete .ui-menu-item img').length != 0) {
          $('.ui-autocomplete .ui-menu-item img').each(function () {
            $(this).attr('src', $(this).attr('src').replace('25-25', '60-60'))
          })
        }
      }, 100)
    });
  },
  floatHeader: function () {
    /*HEADER FIXO*/
    var previousScroll = 0;
    $(window).scroll(function () {
      var headerHeight = $('.pageheader').height();

      if ($(window).scrollTop() >= 30) {
        $('body').addClass('floatElement');
        $('.pageheader').addClass('floatHeader');
      } else {
        $('body').removeClass('floatElement');
        $('.pageheader').removeClass('floatHeader');
        $('body header .bottomHeader').show();
      }

      var currentScroll = $(this).scrollTop();
      if (currentScroll < previousScroll && $(window).scrollTop() >= headerHeight) {
        $('.pageheader').addClass('floatHeader');
        $('.pageheader').removeClass('slidUp');
      } else if ($(window).scrollTop() >= 30) {
        $('.pageheader').addClass('slidUp');
      }

      previousScroll = currentScroll;

    });
    /*FIM HEADER FIXO*/
  },
  init: function () {
    global.isLogged();
    global.selectToggle();
    global.menuToggle();
    if (window.innerWidth > 1024) {
      global.floatHeader();
    }
    global.searchResizeImage();
    fns.newsletter($('#nesletter-footer'));
  }
}

$(window).resize(function () {
  fns.isMobile();
  if (window.innerWidth < 1024 && $('.searchBox').hasClass('is-desktop')) {
    $('.searchBox').slideDown().toggleClass('is-desktop');
  }
})


$(document).ready(function () {
  $('.helperComplement').remove();
  global.init();

  if (HOME) {
    home.init();
  }

  if (PRODUTO) {
    product.init();
  }

  // if (ACCOUNT) {
  //   account.init();
  // }

  if (CATALOG) {
    catalog.init();
  }

  if (EMPTYSEARCH) {
    emptSearch.init();
  }

  if (SEARCH) {
    search.init();
  }

  if (INSTITUTIONAL) {
    var currentePage = window.location.pathname;
    $('.institutionalLinksList a').each(function () {
      var link = $(this).attr('href')
      if (link == currentePage) {
        $(this).addClass('active');
      }
    });
  }
})
